var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pcg-text-input',{attrs:{"error-text":_vm.nameError,"label":_vm.$t('general.name'),"show-error":!!_vm.nameError,"value":_vm.name},on:{"input":function($event){return _vm.input('name', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }